<template>
<div class="apply" style="height: 1080px; width:1180px;">
    <diV class="wrap">
        <div class="con">
            <div class="title">
                <h2>전체클래스 상세 보기</h2>
                <p>본 화면은 PC에 최적화 되어 있습니다.</p>
            </div>

            <!-- <div class="mt-30" v-for="(subject, idx) of subjectList" :key="idx"> -->
            <div class="mt-30">
                <!-- <h3 class="mb-10">{{classList[idx].class_name}}</h3> -->
                <table class="hq-table-col">
                    <thead>
                        <tr>
                            <th class="txt-center" v-if="showColumn('언어')">언어</th>
                            <th class="txt-center" v-if="showColumn('과정명')">클래스명</th>
                            <th class="txt-center" v-if="showColumn('레벨')">레벨</th>
                            <th class="txt-center" v-if="showColumn('요일')">요일</th>
                            <th class="txt-center" v-if="showColumn('교육시간')">교육시간</th>
                            <th class="txt-center" v-if="showColumn('장소')">장소</th>
                            <th class="txt-center" v-if="showColumn('강사')">강사</th>
                            <th class="txt-center" v-if="showColumn('교육비')">교육비</th>
                            <th class="txt-center" v-if="showColumn('교재비')">교재비</th>
                            <th class="txt-center" v-if="showColumn('상세 및 기타')">상세 및 기타</th>
                            <th class="txt-center" v-if="wait_num_YN=='Y'" >모집인원</th>
                            <th class="txt-center" v-if="wait_num_YN=='Y'" >대기자</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) of subjectList" :key="index">
                            <td v-if="showColumn('언어')">{{item.language || '-'}}</td>
                            <td v-if="showColumn('과정명')" class="break-all">{{item.subjectName || '-'}}</td>
                            <td v-if="showColumn('레벨')" class="bold">{{item.level || '-'}}</td>
                            <td v-if="showColumn('요일')">{{replaceDate(item.day)}}</td>
                            <td v-if="showColumn('교육시간')">{{item.subjectStartTime}}~{{item.subjectEndTime}}</td>
                            <td v-if="showColumn('장소')">{{item.place || '-'}}</td>
                            <td v-if="showColumn('강사')">{{item.teacher || '-'}}</td>
                            <td v-if="showColumn('교육비')">{{item.eduPrice || '-'}}</td>
                            <td v-if="showColumn('교재비')">{{item.bookPrice || '-'}}</td>
                            <td v-if="showColumn('상세 및 기타')" class="pointer txt-blue" @click="openModal(item)">view</td>
                            <td v-if="wait_num_YN=='Y'" >
                                <span v-if="item.faType === 'AF' || item.faType === 'SF'">
                                    {{item.faNum}}
                                </span>
                                <span v-else>
                                    제한없음
                                </span>
                            </td>
                            <td v-if="wait_num_YN=='Y'" >
                                <span v-if="item.faType === 'AF' || item.faType === 'SF'">
                                    {{item.waitingNum}}
                                </span>
                                <span v-else>
                                    제한없음
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>

    <etc-modal v-if="isEtcModalOpened" :etc="etc" @close="closeModal"></etc-modal>
</div>
</template>

<script>
import EtcModal from '@/components/reg/select/etcModal.vue'
export default {
    components: {
        EtcModal
    },
    data: () => ({
        isEtcModalOpened: false, // 상세 및 기타 모달 on/off
        classList: [], // 과목 리스트
        subjectList: [],
        wait_num_YN:"N",

        classIdx: '', // 현재 선택된 클래스 아이디
        title: '',
        columnList: [], // 관리자단에서 설정한 컬럼명 리스트
    }),

    mounted() {
        var oParams = this.getUrlParams()
        // console.log('oParams', oParams)
        if (typeof oParams.programIdx !== 'undefined') {
            var programIdx = oParams.programIdx
            var params = {
                programIdx: programIdx
            }
            this.axios.get(this.axios.root + this.axios.port + `/program/${programIdx}`, {
                params: params
            }).then(res => {
                // console.log('res', res)
                if (res.data.err === 0) {
                    this.classList = res.data.classList
                    this.subjectList = res.data.subjectList
                    this.wait_num_YN = res.data.main.wait_num_YN;

                    this.title = res.data.title
                    document.title = this.title

                    // 클래스 항목이 있는것만 array형태로 추가
                    if (this.subjectList.length > 0) {
                        this.columnList = this.subjectList[0].columnOrder.split('^')
                    }

                    // 등록된 클래스가 존재할 때 처음 클래스를 기본 클래스로 지정
                    if (this.classList.length > 1) {
                        this.classIdx = this.classList[0].idx
                    }
                } else {
                    alert(res.data.result)
                }
            })
        }
    },

    methods: {
        // 관리자단에서 설정한 컬럼만 보여주기
        showColumn (type) {
            if (this.columnList.includes(type)) {
                return true
            } else {
                return false
            }
        },

        // 모달 열기
        openModal(etc) {
            this.etc = etc
            this.isEtcModalOpened = true
        },

        // 모달 닫기
        closeModal() {
            this.isEtcModalOpened = false
        },

        // url 파라미터 오브젝트화
        getUrlParams() {
            var params = {}
            window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
                params[key] = value
            })
            return params
        },

        // 월^화^수 => 월, 화, 수
        replaceDate(rawDate) {
            var date = rawDate.replace(/\^/gi, ', ')
            return date
        }
    }
}
</script>
